export default __webpack_public_path__ + "static/media/money-saving.bf780663.svg";